import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" class=\"create-button-icon\" id=\"icon-add\"><defs><clipPath id=\"icon-add_mg-icon158a\"><rect width=\"16\" height=\"16\" rx=\"0\" /></clipPath></defs><g clip-path=\"url(#icon-add_mg-icon158a)\"><path fill=\"currentcolor\" fill-opacity=\".85\" fill-rule=\"evenodd\" d=\"M7.5 8.5V14h1V8.5H14v-1H8.5V2h-1v5.5H2v1z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol